import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Pretendard 폰트를 CDN으로 불러오기 */
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

  body {
    font-family: 'pretendard', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  button {
    font-family: 'pretendard', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* 스크롤바 커스터마이징 */
  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888; 
    border-radius: 10px;
    border: 3px solid #f1f1f1; /* Adds padding around scrollbar thumb */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  /* 파이어폭스용 스크롤바 스타일 */
  body {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
  }

  h1,h2,h3,h4,h5,h6 {
    font-weight: 700;
  }

  /* 체크박스 스타일링 */
  input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border: 1px solid #ddd; /* 초록색 테두리 */
    border-radius: 4px;
    position: relative;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  input[type="checkbox"]:checked {
    background-color: #238C64; /* 초록색 배경 */
  }

  input[type="checkbox"]:checked::before {
  content: '✔'; /* 체크 표시 (체크 아이콘) */
  position: absolute;
  top: -1px;
  left: 2.5px;
  font-size: 12px; /* 체크 아이콘 크기 */
  color: white; /* 체크 표시 색상 */
}



`;

export default GlobalStyle;
